/* eslint-disable @typescript-eslint/unbound-method */
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { StoreService } from '@se-po/se-household-setup-data-access-store'

export interface MatchFormSubmitter {
  signIn: (signInForm: HTMLFormElement) => void
  noMatch: (store: StoreService) => void
  reset: (store: StoreService) => void
}

@Injectable({
  providedIn: 'root'
})
export class MatchFormSubmitService implements MatchFormSubmitter {
  public submitting = false

  constructor(
    public router: Router
  ) {}

  public signIn(signInForm: HTMLFormElement): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    signInForm.nativeElement.submit()
  }

  public noMatch(store: StoreService): void {
    this.router.navigate([store.basePath, store.nextPath])
  }

  public reset(store: StoreService): void {
    this.router.navigate([store.basePath])
  }
}
